module.exports = __webpack_public_path__ + "d2201014e28cc2498e6e412aa011b7eb.png";